export default __webpack_public_path__ + "static/media/zcash.4d1f40fb.png";